import Api from "../api";
let uri = '/api/ed/encuesta';
let uriPregunta = '/api/ed/pregunta/tipo';
let uriRespuesta = '/api/ed/respuesta/tipo';
let uriRespuestas = '/api/ed/pregunta/respuestas';

export const getEncuestas = (data) => {
    return Api.getInstance().executeQuery(`${uri}/list`, data)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const adminEncuestas = (data) => {
    return Api.getInstance().executeQuery(`${uri}`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error) 
    );
}

export const getPreguntasEncuesta = (data) => {
    return Api.getInstance().executeQuery(`${uri}/preguntas`, data)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}


export const adminPreguntas = (data) => {
    return Api.getInstance().executeQuery(`${uri}/pregunta`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}

export const getRespuestasPregunta = (data) => {
    return Api.getInstance().executeQuery(`${uriRespuestas}`, data)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const adminRespuestas = (data) => {
    return Api.getInstance().executeQuery(`${uri}/respuesta`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}

export const listEncuesta = (data) => {
    return Api.getInstance().executeQuery(`${uri}/list`, data)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const getTipoPregunta = () => {
    return Api.getInstance().executeGetQuery(`${uriPregunta}`)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const getTipoRespuesta = () => {
    return Api.getInstance().executeGetQuery(`${uriRespuesta}`)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const postRespuestaEncuesta = (data) => {
    return Api.getInstance().executeQuery(`${uri}/acta`, data)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}


